/**
 * Site configuration — change SITE_NAME here to update it everywhere.
 * You can also override it via the NEXT_PUBLIC_SITE_NAME environment variable.
 */
export const SITE_NAME =
  process.env.NEXT_PUBLIC_SITE_NAME || 'IndianReviewClub';

export const SITE_TAGLINE = "India's Most Trusted Product Review Platform";

export const SITE_CONFIG = {
  name: SITE_NAME,
  tagline: SITE_TAGLINE,
  url: process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000',
} as const;
